<template>
  <div class="header_notice">
    <Badge :count="count" overflow-count="99" style="margin-left:20px;">
      <Icon :size="30" type="ios-notifications" @click="handleClick" style="cursor: pointer;"/>
    </Badge>
  </div>
</template>

<script>
import './notice.less'
import { mapActions } from 'vuex'
export default {
  name: 'Notice',
  props: {
    count: {
      type: Number,
      default: ''
    }
  },
  methods: {
    handleClick (name) {
      this.$router.push(`/noticeMain_page`)
    }
  }
}
</script>
